import ApiHelper from "../../helpers/ApiHelper";
import GeneralHelper from "../../helpers/GeneralHelper";
import BaseService from "../BaseService";

class KeywordService extends BaseService {

    static url = "keywords";
    static apis = {
        that: this,
        
        getKeywords:function(){
            return this.that.url
        },
        deleteKeyword:function(){
            return this.that.url
        },

        setKeywords:function(){
            return this.that.url
        },

        setkeywordsUnAuthenticated:function(){
            return this.that.url+'/no-auth'
        }
    }

    constructor(repo) {
        super(repo);
        this.repo = new ApiHelper("keywords");
    }

    getKeywords() {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: KeywordService.apis.getKeywords(),
                    method: "GET",
                    showLoader: true,
                    authorization: true,
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    deleteKeyword(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: KeywordService.apis.deleteKeyword(),
                    method: "DELETE",
                    showLoader: true,
                    authorization: true,
                    data:data
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    setkeywords(data){
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: KeywordService.apis.setKeywords(),
                    method: "POST",
                    showLoader: false,
                    authorization: true,
                    data:data
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    setkeywordsUnAuthenticated(data){
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: KeywordService.apis.setkeywordsUnAuthenticated(),
                    method: "POST",
                    showLoader: false,
                    authorization: false,
                    data:data
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }
}


export default KeywordService;